import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    InventoryBarcodeSearchPageComponent
} from "../inventory-barcode-search-page/inventory-barcode-search-page.component";
import {InventoryBarcodeSearchModel} from "../inventory-barcode-search.model";

@Component({
    selector: "wbo-inventory-barcode-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(InventoryBarcodeSingleSelectEditControlComponent),
        provideSearchModel(InventoryBarcodeSearchModel)
    ]
})
export class InventoryBarcodeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<InventoryBarcodeSearchModel> {

    constructor(model: InventoryBarcodeSearchModel, injector: Injector) {
        super(model, injector, "inventoryBarcodeId", "fullName");
        this.labelSearchField = "identifier";
        this.extendedSearchComponent = InventoryBarcodeSearchPageComponent;
    }
}
